<template>
  <form v-if="setting" class="form" v-on:submit.prevent="updateSetting">
    <h1>System Setting: {{ setting.name }}</h1>
    <div class="box">
      <Errors />
      <SystemSettingFields />
      <div class="form-wrap form-submit">
        <div class="mt-1" v-if="this.getLoadStatus">
          <button type="submit" class="button" disabled>
            <span>Updating...</span>
          </button>
        </div>
        <div class="mt-1" v-else>
          <button type="submit" class="button">
            <span>Update setting</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import SystemSettingFields from "@/components/SystemSettingFields.vue";
import Errors from "@/components/Errors.vue";
import { mapGetters } from "vuex";
export default {
  name: "SystemSettingEdit",
  computed: mapGetters(["getLoadStatus"]),
  data() {
    return {
      setting: null,
      errors: null
    };
  },
  components: {
    SystemSettingFields,
    Errors
  },
  created() {
    this.getSetting();
  },
  watch: {
    $route: "getSetting"
  },
  methods: {
    getSetting() {
      this.$store.dispatch("setLoadStatus");
      fetch(this.$api + "settings/system/" + this.$route.params.id, {
        headers: {
          Accept: "application/json",
          Authorization: localStorage.getItem("token")
        }
      })
        .then(res => res.json())
        .then(response => {
          this.$store.dispatch("setLoadStatus");
          this.setting = response.data[0];
        });
    },
    updateSetting() {
      this.$store.dispatch("setLoadStatus");
      fetch(this.$api + "settings/system/" + this.$route.params.id, {
        method: "POST",
        body: JSON.stringify(this.setting),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: localStorage.getItem("token")
        }
      })
        .then(res => res.json())
        .then(response => {
          console.log(response);
          if (response.success) {
            this.$notify({
              type: "success",
              title: response.message
            });
          } else if (response.errors) {
            this.$notify({
              type: "error",
              title: response.message
            });
          }
          this.$store.dispatch("setLoadStatus");
        });
    }
  }
};
</script>
